import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { loadEnv } from '@dma/config';
import { applyThemeTokens } from '@dma/ui';
import { App } from './App';
import { createCompositionRoot } from './composition-root';
import '../styles/global.css';

// Must run before the first paint: every component's CSS references
// `var(--dma-color-...)`, `var(--dma-spacing-...)`, etc. — without this
// call those custom properties are never defined on :root, which makes
// every declaration using them invalid (spacing/colors/radii collapse
// site-wide, not just look "slightly off"). See css-variables.ts for why.
applyThemeTokens();

const env = loadEnv(import.meta.env);
const compositionRoot = createCompositionRoot(env);

compositionRoot.logger.info('Application starting', { appEnv: env.VITE_APP_ENV });

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('main.tsx: could not find #root element to mount the application.');
}

createRoot(rootElement).render(
  <StrictMode>
    <App compositionRoot={compositionRoot} />
  </StrictMode>
);
